import * as React from "react";
import styled from "styled-components";

import * as Styles from "@/utils/styles";

// ========================= //
// ↓↓↓ Styled Components ↓↓↓ //
// ========================= //s

export const SVG = styled("svg").attrs(() => ({
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 10 10",
}))`
	fill: ${Styles.Colors.LIGHT.seven};
	transition: 0.15s ease-in;

	:hover {
		fill: ${Styles.Colors.PRIMARY};
	}
`;

// ================= //
// ↓↓↓ Component ↓↓↓ //
// ================= //

type Props = { height?: number };

export const AngelList = (props: Props) => {
	return (
		<SVG height={props.height || "10"}>
			<g clipPath="url(#A)">
				<path d="M6.866 4.157l.718-2.065c.171-.542.257-.876.257-1 0-.132-.029-.236-.086-.308S7.621.674 7.518.674c-.128 0-.262.106-.391.319s-.28.555-.443 1.027l-.687 1.985.863.151h.007zm-.914 1.85c-.188-.012-.375-.033-.56-.063a3.17 3.17 0 0 1-.508-.137 4.48 4.48 0 0 1 .197.438 3.68 3.68 0 0 1 .142.433 3.21 3.21 0 0 1 .347-.376 2.98 2.98 0 0 1 .381-.3l.002.005zm-.777-2.084L4.434 1.78c-.194-.547-.342-.9-.448-1.071S3.768.458 3.644.458c-.096 0-.174.034-.234.109s-.088.171-.088.291c0 .209.078.575.236 1.101l.721 2.055c.025-.049.066-.088.117-.109a.56.56 0 0 1 .204-.033l.163.003.406.038.008.01zM4.502 7.24c.078 0 .15-.038.212-.108.063-.075.098-.15.098-.229 0-.088-.062-.291-.187-.609-.131-.325-.289-.639-.472-.938-.137-.229-.272-.404-.404-.521s-.26-.174-.38-.174c-.096 0-.202.059-.319.182s-.176.234-.176.339.059.275.173.492.269.454.459.7c.204.27.392.479.572.628s.321.226.425.226v.012zM2.44 7.074l.269.342c.301.417.581.625.839.625.085 0 .168-.03.234-.083.068-.059.103-.112.103-.176 0-.07-.046-.182-.137-.345s-.218-.342-.38-.542c-.182-.233-.335-.404-.458-.513s-.218-.163-.29-.163c-.158 0-.31.088-.441.259-.134.166-.2.375-.2.609 0 .187.049.396.145.628a3.15 3.15 0 0 0 .409.697 2.78 2.78 0 0 0 1.01.834c.399.19.845.287 1.329.287.892 0 1.643-.332 2.244-1s.904-1.501.904-2.506a3.12 3.12 0 0 0-.067-.733c-.046-.179-.12-.313-.225-.396-.187-.159-.555-.296-1.096-.422a7.53 7.53 0 0 0-1.702-.187c-.163 0-.283.029-.35.083s-.099.15-.099.28c0 .313.174.539.524.679s.914.212 1.694.212h.282a.19.19 0 0 1 .153.073c.038.046.063.116.075.217-.078.07-.236.155-.48.249s-.43.189-.558.279c-.267.193-.492.437-.663.718-.166.275-.251.537-.251.785 0 .15.036.334.108.546s.109.344.109.397v.046l-.013.062c-.2-.011-.358-.13-.476-.353s-.174-.518-.174-.889v-.062a.39.39 0 0 1-.109.068c-.036.014-.074.022-.112.021a.95.95 0 0 1-.12-.008c-.041-.007-.081-.018-.12-.031l.031.147.008.112a.57.57 0 0 1-.2.438c-.132.119-.291.179-.474.179-.288 0-.583-.142-.881-.422s-.445-.558-.445-.827c0-.049.005-.096.016-.133s.031-.073.059-.101l-.021.021zm4.921-2.806c.412.075.703.251.871.521s.256.692.256 1.275c0 1.156-.345 2.097-1.039 2.832S5.866 10 4.787 10a3.45 3.45 0 0 1-1.241-.233 3.17 3.17 0 0 1-1.039-.643c-.329-.303-.58-.62-.741-.958a2.31 2.31 0 0 1-.251-1.034c0-.396.083-.7.251-.914s.436-.363.804-.441a2.61 2.61 0 0 1-.15-.409c-.034-.112-.05-.195-.05-.254 0-.209.108-.422.326-.633s.42-.326.612-.326c.078 0 .166.013.259.046s.195.08.313.147l-.756-2.293c-.163-.547-.241-.917-.241-1.125 0-.285.07-.513.217-.681S3.45 0 3.699 0c.43 0 .977.962 1.64 2.886l.262.762.212-.606C6.476 1.146 7.044.195 7.523.195c.233 0 .422.08.558.238s.209.37.209.635c0 .2-.08.567-.233 1.104l-.695 2.096z" />
			</g>
			<defs>
				<clipPath id="A">
					<path fill="#fff" d="M0 0h10v10H0z" />
				</clipPath>
			</defs>
		</SVG>
	);
};
